<template>
  <div class="Complete_body">
    <textarea id="autocomplete"
              v-model="text"
              class="Complete_text form-control form-control-sm"
              name="textautocomplete"
              cols="30"
              rows="4"
              @keyup="search"
              @focus="search"
              @change="submitText" />
    <ul v-if="exibir"
        class="Complete_list">
      <li v-for="(item, index) in sugestoes"
          :key="index"
          class="Complete_list_option"
          @click="selectOptionClick(item)">
        {{ item }}
      </li>
    </ul>
  </div>
</template>
<script>
  /* services */
  import RegimeBensService from "@/services/Registros/RegimeBensService"

  export default {
    name: "TextAutoComplete",
    props: {
      propList: {type: Array, default: () => ([])},
      propHabilitacao: {type: Object, default: () => ({})}
    },
    data () {
      return {
        text: "",
        sugestoes: [],
        exibir: false,
        indicador: -1,
        list: []
      }
    },
    watch: {
      propList () {
        this.list = this.propList
        this.sugestoes = this.list
        this.exibir = false
        this.indicador = -1
      },
      sugestoes () {
        if (this.sugestoes[0] == undefined) {
          this.exibir = false
          this.indicador = -1
        }
      },
      propHabilitacao () {
        this.text = this.propHabilitacao.regime_bens_complemento
      }
    },
    mounted () {
      this.text = this.propHabilitacao.regime_bens_complemento
    },
    methods: {
      submitText () {
        this.$emit("change", this.text)

        setTimeout(() => {
          this.exibir = false
          this.indicador = -1
        }, 200)
      },
      async search (event) {
        await this.getComplemento()

        const { key } = event

        if (!this.text) {
          this.exibir = false
          this.sugestoes = []
          this.indicador = -1
          return
        }

        if (["Enter", "ArrowDown", "ArrowUp"].indexOf(key) != -1 && this.sugestoes.length) {
          this.selectOptionKey(key)
        }

        this.exibir = true

        this.sugestoes = this.list.map(res => {
          if (!res.match(this.text)) return

          return res.match(this.text).input
        })

        this.sugestoes = this.sugestoes.filter(res => res != undefined)
          .filter((res, index) => res && index < 10)
      },
      selectOptionKey (key) {
        const elements = document.querySelectorAll('.Complete_list_option')

        if (key === "ArrowDown") {
          if (elements[this.indicador]) {
            elements[this.indicador].style.background = "white"
            elements[this.indicador].style.color = "#495057"
          }
          this.indicador++
        }

        else if (key === "ArrowUp") {
          if (elements[this.indicador]) {
            elements[this.indicador].style.background = "white"
            elements[this.indicador].style.color = "#495057"
          }
          this.indicador--
        }

        else if (key === "Enter") {
          if (elements[this.indicador]) {
            this.text = elements[this.indicador].innerText
            this.submitText()
            this.indicador = -1
            return
          }
        }

        if (this.indicador > elements.length - 1) this.indicador = 0
        if (this.indicador < 0) this.indicador = elements.length - 1

        if (elements.length) {
          elements[this.indicador].style.background = "#1c7af5"
          elements[this.indicador].style.color = "white"
        }

      },
      async getComplemento () {
        const { data } = await RegimeBensService.getRegimeBens({
          cartorio_id: this.$store.state.auth.cartorio_id,
          descricao: this.propHabilitacao.regime_bens
        })

        this.list = data && data.map(regime => regime.complemento)
        this.sugestoes = this.list
      },
      selectOptionClick (complemento) {
        if (complemento) {
          this.text = complemento
        }

        this.submitText()
      },
    }
  }
</script>
<style scoped lang="scss">
	.Complete {
		&_body {
			position: relative;
		}

		&_text {
			width: 100%;
		}

		&_list {
			cursor: pointer;
			background: white;
			width: 100%;
			list-style-type: none;
			padding: 0;
			border-top: none ;
			padding: 5px;
			position: absolute;
			z-index: 9999;
			box-shadow: 0 0 0 0.09rem rgba(0, 0, 0, 0.2);
			color: #495057;

			&_option {
				font-size: 16px;
				font-family: Roboto;
				padding: 5px;
			}

			&_option :hover{
				background: #1c7af5;
				color: white;
			}
		}

		&_list :hover {
			background: #1c7af5;
			color: white;
		}
	}
</style>
